import React from 'react'
import { Section, GuideHeader, P, UI, Steps, Bullets, Callout } from './GuideParts'

export default function OutlookAddinGuide() {
  return (
    <div className="space-y-8">
      <GuideHeader
        title="Outlook Add-in"
        intro="Send attachments from your inbox to Xtract AI without leaving Outlook."
      />

      <Section number={1} title="What the Add-in Does">
        <Bullets>
          <li>Open any email with attachments and choose which documents to process.</li>
          <li>Pick the template to extract against.</li>
          <li>See upload and extraction progress in the Outlook side panel.</li>
          <li>Get a warning when a document has already been processed (duplicate detection).</li>
          <li>Password-protected PDFs are handled automatically.</li>
        </Bullets>
      </Section>

      <Section number={2} title="Sending Documents from Outlook">
        <Steps>
          <li>Open an email in Outlook (web or desktop).</li>
          <li>Choose the <UI>Xtract</UI> button in the ribbon. The side panel shows the email’s attachments.</li>
          <li>Tick the documents to process and choose a template.</li>
          <li>Choose <UI>Submit</UI>. Files are uploaded and extraction starts.</li>
          <li>Follow the request in the add-in, or open it under Requests in the web app. Review and approval happen in the web app.</li>
        </Steps>
      </Section>

      <Section number={3} title="Requirements and Sign-in">
        <P>
          You need Microsoft 365 with Outlook and the Xtract add-in installed for your organisation. It uses the same Microsoft work
          account as the web app. If the add-in is missing from your ribbon, ask your Admin to deploy it.
        </P>
        <Callout kind="warn" title="“You are not assigned to any OpCo”">
          If your organisation uses OpCos and nothing places you in one (you belong to none and the email’s mailbox or domain matches none),
          the add-in lists no templates and tells you to ask a Super Admin to assign you to an OpCo. Super Admins can instead choose
          “No OpCo (Unassigned)” on purpose.
        </Callout>
        <Callout kind="info">
          Requests created from the add-in are recorded under the application’s sign-in, not under your own name, in
          Billing &amp; Analytics.
        </Callout>
      </Section>

      <Section number={4} title="For Admins: Branding and Routing">
        <P>
          The add-in’s name and logo are set under <UI>Settings</UI> &gt; Outlook add-in. If your organisation uses OpCos, a Super Admin can
          route mail from a mailbox or domain to the right OpCo (Users &amp; Groups &gt; OpCos &gt; Domains &amp; mailboxes).
        </P>
      </Section>
    </div>
  )
}
